import React, { useEffect, useState } from "react";
import { Clock, AlertTriangle, LogOut, UserRound } from "lucide-react";
import { api } from "@/lib/api";
import { useAppAuth } from "@/auth/AppAuthProvider";

export default function Topbar() {
  const { principal, logout } = useAppAuth();
  const [time, setTime] = useState(new Date());
  const [conflictCount, setConflictCount] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    api.dashboard()
      .then(d => setConflictCount(d.conflicts_total || 0))
      .catch(() => {});
  }, []);

  const utc = time.toISOString().slice(0, 19).replace("T", " ");

  return (
    <header className="h-14 border-b border-[#1E293B] bg-[#0E1522] flex items-center px-6 ml-64 sticky top-0 z-20">
      <div className="flex items-center gap-3">
        <div className="text-xs font-mono uppercase tracking-widest text-slate-500">Operations Console</div>
      </div>
      <div className="ml-auto flex items-center gap-6">
        {conflictCount > 0 && (
          <div className="flex items-center gap-2 px-3 py-1 sev-warning" data-testid="topbar-conflict-count">
            <AlertTriangle size={14} />
            <span className="font-mono text-xs">{conflictCount} active conflicts</span>
          </div>
        )}
        <div className="flex items-center gap-2 text-slate-300">
          <Clock size={14} className="text-sky-400" />
          <span className="font-mono text-xs">{utc} UTC</span>
        </div>
        <div className="flex items-center gap-2 border-l border-[#1E293B] pl-5">
          <UserRound size={14} className="text-sky-400" />
          <div className="leading-tight">
            <div className="text-xs text-slate-200">{principal?.name || principal?.email || "Signed in"}</div>
            <div className="font-mono text-[9px] uppercase text-slate-500">{principal?.roles?.[0] || "user"}</div>
          </div>
          {principal?.issuer !== "local-development" && (
            <button type="button" onClick={logout} className="text-slate-500 hover:text-slate-200" aria-label="Sign out" title="Sign out">
              <LogOut size={14} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
